import { render, staticRenderFns } from "./ReturnPopup.vue?vue&type=template&id=413c2963&"
import script from "./ReturnPopup.vue?vue&type=script&lang=ts&"
export * from "./ReturnPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports